import { render, staticRenderFns } from "./FormSpeciality.vue?vue&type=template&id=68e17afa&"
import script from "./FormSpeciality.vue?vue&type=script&lang=js&"
export * from "./FormSpeciality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports